import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import {
  OUTPUT_FILE_TYPES,
  MODEL_GROUP,
  INITIALIZATION_GROUP,
  PARAMETER_GROUP,
  SOLUTION_GROUP,
} from '../../services/BatchFileValidator';
import ResultFileListItem from './ResultFileListItem';

import './SelectResultFileTypeDialog.scss';

const GROUP_TITLES = {
  [MODEL_GROUP]: 'Model files',
  [INITIALIZATION_GROUP]: 'Other files',
  [PARAMETER_GROUP]: 'Parameter files',
  [SOLUTION_GROUP]: 'Solution files',
};

class SelectResultFileTypeDialog extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    viewService: PropTypes.shape({}).isRequired,
    open: PropTypes.bool.isRequired,
    selectedTypes: PropTypes.arrayOf(PropTypes.shape({})),
  };

  static defaultProps = {
    selectedTypes: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      title: 'Select result file formats',
      ...this.getInitialState(),
    };

    // Bindings
    this.handleUseTypeFile = this.handleUseTypeFile.bind(this);
  }

  getInitialState() {
    const { selectedTypes } = this.props;
    const allTypeFiles = OUTPUT_FILE_TYPES.map(type => ({ type, use: selectedTypes.indexOf(type) >= 0 }));
    return {
      allTypeFiles,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.setState(this.getInitialState());
    }
  }

  handleCancel = () => {
    this.setState(this.getInitialState());
    this.props.onClose(null);
  };

  handleOk = () => {
    const { allTypeFiles } = this.state;
    this.props.onClose(allTypeFiles.filter(file => file.use).map(file => file.type));
  };

  handleUseTypeFile(file, checked) {
    const { allTypeFiles } = this.state;
    const newFile = { ...file, use: checked };
    const replace = (files) => {
      const index = files.indexOf(file);
      if (index >= 0) {
        const newFiles = files.slice();
        newFiles[index] = newFile;
        return newFiles;
      }
      return files;
    };
    this.setState({
      allTypeFiles: replace(allTypeFiles),
    });
  }

  render() {
    const { open } = this.props;
    const { title, allTypeFiles } = this.state;

    const GroupList = group => (
      <div className={`grbrsm-select-resulttype-group grbrsm-select-resulttype-group-${group}`}>
        <Typography variant="h6">{GROUP_TITLES[group]}</Typography>
        <List
          component="nav"
          aria-label="result type list"
          className="grbrsm-resulttype-list"
          dense
          disablePadding
        >
          {allTypeFiles.filter(file => file.type.group === group).map((file) => (
            <ResultFileListItem
              {...this.props}
              key={file.type.ext}
              file={file}
              onCheck={this.handleUseTypeFile}
            />
          ))}
        </List>
      </div>
    );
    return (
      <Dialog
        disableBackdropClick
        aria-labelledby="grbrsm-select-resulttype-title"
        className="grbrsm-resulttype-dialog"
        maxWidth="lg"
        style={{ maxHeight: 'unset' }}
        onClose={this.handleCancel}
        open={open}
      >
        <DialogTitle id="grbrsm-select-resulttype-title">{title}</DialogTitle>
        <DialogContent>
          <section className="grbrsm-select-resulttype-grouplist">
            {GroupList(SOLUTION_GROUP)}
            {GroupList(MODEL_GROUP)}
          </section>
          <section>
            {GroupList(INITIALIZATION_GROUP)}
            {GroupList(PARAMETER_GROUP)}
          </section>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleOk} color="primary">
            Select
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default SelectResultFileTypeDialog;
